/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { CotizadorContext } from '../context';

const useContactUrl= () => {
    const [state, setState] = useContext(CotizadorContext)



    const setContactUrl= (contact_url) => {
        setState((prevState) => ({
            ...prevState,
            contact_url,
        }));
    };

    return {
        contact_url: state.contact_url,
        setContactUrl,
    };
}

export default useContactUrl;